import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        isScrolled || isMobileMenuOpen ? 'bg-white/95 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/402fb013a15abdbe1b740b2d8ca8aa4c/a0082163fda938ccc063740b372592ae.png"
              alt="Satori Energia"
              className="h-10 md:h-16 transition-all duration-300 transform hover:scale-105 cursor-pointer"
              onClick={() => scrollToSection('hero')}
            />
          </div>

          <div className="md:hidden">
            <button
              className={`${isScrolled || isMobileMenuOpen ? 'text-[#003366]' : 'text-white'} w-10 h-10 flex items-center justify-center`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          <nav className="hidden md:flex items-center justify-center flex-grow">
            <ul className="flex space-x-1">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className={`px-4 py-2 text-sm font-medium cursor-pointer transition-colors duration-300 whitespace-nowrap ${
                    isScrolled
                      ? 'text-[#003366] hover:text-[#FFD700]'
                      : 'text-white hover:text-[#FFD700]'
                  }`}
                >
                  Sobre
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className={`px-4 py-2 text-sm font-medium cursor-pointer transition-colors duration-300 whitespace-nowrap ${
                    isScrolled
                      ? 'text-[#003366] hover:text-[#FFD700]'
                      : 'text-white hover:text-[#FFD700]'
                  }`}
                >
                  Serviços
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('benefits')}
                  className={`px-4 py-2 text-sm font-medium cursor-pointer transition-colors duration-300 whitespace-nowrap ${
                    isScrolled
                      ? 'text-[#003366] hover:text-[#FFD700]'
                      : 'text-white hover:text-[#FFD700]'
                  }`}
                >
                  Benefícios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className={`px-4 py-2 text-sm font-medium cursor-pointer transition-colors duration-300 whitespace-nowrap ${
                    isScrolled
                      ? 'text-[#003366] hover:text-[#FFD700]'
                      : 'text-white hover:text-[#FFD700]'
                  }`}
                >
                  FAQ
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className={`px-4 py-2 text-sm font-medium cursor-pointer transition-colors duration-300 whitespace-nowrap ${
                    isScrolled
                      ? 'text-[#003366] hover:text-[#FFD700]'
                      : 'text-white hover:text-[#FFD700]'
                  }`}
                >
                  Contato
                </button>
              </li>
            </ul>
          </nav>

          <div className="hidden md:flex justify-end items-center space-x-5">
            <a
              href="https://www.youtube.com/channel/UClGShZvxU9U9vmGAnHorx6A"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-all duration-300 transform hover:scale-125 ${
                isScrolled ? 'text-[#003366] hover:text-[#4A90E2]' : 'text-white hover:text-[#FFD700]'
              }`}
              aria-label="YouTube"
            >
              <i className="ri-youtube-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://www.facebook.com/satorienergia"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-all duration-300 transform hover:scale-125 ${
                isScrolled ? 'text-[#003366] hover:text-[#4A90E2]' : 'text-white hover:text-[#FFD700]'
              }`}
              aria-label="Facebook"
            >
              <i className="ri-facebook-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/74341299/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-all duration-300 transform hover:scale-125 ${
                isScrolled ? 'text-[#003366] hover:text-[#4A90E2]' : 'text-white hover:text-[#FFD700]'
              }`}
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://www.instagram.com/satorienergia"
              target="_blank"
              rel="noopener noreferrer"
              className={`transition-all duration-300 transform hover:scale-125 ${
                isScrolled ? 'text-[#003366] hover:text-[#4A90E2]' : 'text-white hover:text-[#FFD700]'
              }`}
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        <div
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="flex flex-col space-y-1 py-2">
            <button
              onClick={() => scrollToSection('about')}
              className="text-left px-4 py-3 cursor-pointer text-[#003366] hover:bg-[#003366]/5 hover:text-[#FFD700] transition-colors duration-300 font-medium rounded-lg"
            >
              Sobre
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-left px-4 py-3 cursor-pointer text-[#003366] hover:bg-[#003366]/5 hover:text-[#FFD700] transition-colors duration-300 font-medium rounded-lg"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('benefits')}
              className="text-left px-4 py-3 cursor-pointer text-[#003366] hover:bg-[#003366]/5 hover:text-[#FFD700] transition-colors duration-300 font-medium rounded-lg"
            >
              Benefícios
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-left px-4 py-3 cursor-pointer text-[#003366] hover:bg-[#003366]/5 hover:text-[#FFD700] transition-colors duration-300 font-medium rounded-lg"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-left px-4 py-3 cursor-pointer text-[#003366] hover:bg-[#003366]/5 hover:text-[#FFD700] transition-colors duration-300 font-medium rounded-lg"
            >
              Contato
            </button>
          </nav>
          <div className="flex justify-center space-x-5 py-4 border-t border-gray-100">
            <a
              href="https://www.youtube.com/channel/UClGShZvxU9U9vmGAnHorx6A"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#003366] hover:text-[#4A90E2] transition-colors duration-300"
              aria-label="YouTube"
            >
              <i className="ri-youtube-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://www.facebook.com/satorienergia"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#003366] hover:text-[#4A90E2] transition-colors duration-300"
              aria-label="Facebook"
            >
              <i className="ri-facebook-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/74341299/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#003366] hover:text-[#4A90E2] transition-colors duration-300"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="https://www.instagram.com/satorienergia"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#003366] hover:text-[#4A90E2] transition-colors duration-300"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
